export default function NotificationBadge({ count }) {
  if (!count) return null;

  const label = count > 9 ? "9+" : String(count);

  return (
    <span
      className="
        absolute -top-1 -right-1
        min-w-[18px] h-[18px]
        px-1
        rounded-full
        bg-rose-500
        text-white
        text-[10px]
        font-extrabold
        border border-black/50
        shadow
        inline-flex items-center justify-center
        leading-none
        z-50
      "
      aria-label={`${count} nouvelle(s) notification(s)`}
    >
      {label}
    </span>
  );
}
